import { useQuery } from '@tanstack/react-query';

import { useFeatureFlags } from '@/modules/common/hooks';
import { getDemoStatus } from '@/modules/demo/api';

const DEMO_STATUS_QUERY_KEY = ['demo', 'status'];

/**
 * Hook to fetch demo status including days left in trial.
 * Only fetches when in demo environment.
 */
export const useDemoStatus = () => {
  const { isDemoEnv } = useFeatureFlags();

  const { data, isLoading, error } = useQuery({
    queryKey: DEMO_STATUS_QUERY_KEY,
    queryFn: getDemoStatus,
    enabled: isDemoEnv,
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
  });

  return {
    daysLeft: data?.daysLeft,
    isLoading,
    error,
  };
};
